<div class="tiime-stepper-header">
  @for (step of steps; track trackByIndex(i); let i = $index; let isLast = $last) {
    <div
      class="tiime-step-header"
      [attr.aria-disabled]="stepIsNavigable(i, step) ? null : true"
      [class.selected]="selectedIndex === i"
      [class.done]="stepIsDone(i, step)"
      (click)="selectStep(i, step)"
    >
      <div class="tiime-step-icon">
        @if (stepIsDone(i, step)) {
          <mat-icon>check_small</mat-icon>
        } @else {
          {{ i | map: mapToStepNumber }}
        }
      </div>
      <div class="tiime-step-label-container">
        @if (step.label) {
          <span class="tiime-step-label">{{ step.label }}</span>
        }
        @if (step.description()) {
          <span class="tiime-step-description">{{ step.description() }}</span>
        }
      </div>
    </div>
    @if (!isLast) {
      <div class="tiime-step-divider" [class.done]="stepIsDone(i, step)"></div>
    }
  }
</div>
<div class="tiime-stepper-content">
  @if (orientation === 'vertical' && selected.label) {
    <div class="tiime-step-content-label">
      {{ selected.label }}
    </div>
  }
  <div [ngTemplateOutlet]="selected.content"></div>
</div>
